var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.desktop)?_c('Sidebar',{attrs:{"device":_vm.device}}):_c('Navbar')
}
var staticRenderFns = []

export { render, staticRenderFns }